export default class
{
    requestTokenSource = {};

    constructor(axios) {
        this.axios = axios;
    }

    /*
     * parameters:
     *    method
     *    url
     *    data (optional)
     *    validator (optional, default: "responseData => responseData.success === true")
     *    selector (optional, default: "responseData => responseData")
     *    axiosOptions (optional)
     *    cancelingPrevious (optional)
     *    requestName (optional)
     */
    async request({method, url, data, validator, selector, axiosOptions, cancelingPrevious, requestName})
    {
        const allAxiosOptions = {
            method,
            url,
            ...axiosOptions
        };
        if (data !== undefined) {
            allAxiosOptions.data = data;
        }
        if (cancelingPrevious === true && requestName !== undefined) {
            const requestTokenSource = this.cancelOngoingRequest(requestName);
            allAxiosOptions.cancelToken = requestTokenSource.token;
        }
        const response = await this.axios(allAxiosOptions);
        if (validator === undefined) {
            validator = (responseData) => responseData.success === true;
        }
        if (!validator(response.data)) {
            throw new Error('invalid api response: ' + JSON.stringify(response));
        }
        if (selector === undefined) {
            selector = responseData => responseData;
        }
        return selector(response.data);
    }

    cancelOngoingRequest(requestName)
    {
        if (this.requestTokenSource[requestName] !== undefined) {
            this.requestTokenSource[requestName].cancel('request canceled programmatically');
        }
        const source = this.axios.CancelToken.source();
        this.requestTokenSource[requestName] = source;
        return source;
    }
}
